import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import BirthCertificateListingContent from './BirthCertificateListingContent';
import useDebounce from '../../../../../../common/hooks/useDebounce';
import BirthCertModal from '../components/BirthCertModal';
// import UpdateModal from '../components/UpdateModal';
import ImageContainer from '../components/ImageContainer';

const INIT_FILTER = {
  q: '',
  sort_by: 'desc',
};

function BirthCertificateListingContainer({
  match,
  history,
  getBirthCertificateList,
  userManagementList,
  userManagementListPager,
  isLoading,
  removeUserManagement,
  showBirthCertificate,
}) {
  const [filter, setFilter] = useState(INIT_FILTER);
  const debouncedFilter = useDebounce(filter, 500);
  const setModal = useContext(ModalContext);

  useEffect(() => {
    getBirthCertificateList(debouncedFilter);

    return () => {
      setModal({ isOpen: false });
    };
  }, [JSON.stringify(debouncedFilter)]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setFilter((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleModal = (data) => {
    setModal({
      isOpen: true,
      content: <BirthCertModal recordData={data} />,
      title: !data ? 'Add Birth Certificate Record' : 'Update User',
      modalSize: 'modal-xl',
    });
  };

  const handleViewImage = (data, page) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ImageContainer info={data} page={page} />,
      title: 'Birth Certificate',
      modalSize: 'modal-xl',
    });
  };

  // const handleEdit = (data) => (e) => {
  //   e.preventDefault();
  //   setModal({
  //     isOpen: true,
  //     content: <UpdateModal updateList={data.attributes} id={data.id} />,
  //     title: 'Update User',
  //     modalSize: 'modal-xl',
  //   });
  // };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this userManagement?',
      () => {
        removeUserManagement(data.id, () => {
          getBirthCertificateList(INIT_FILTER);
          const id = _.get(userManagementList, '0.id');
          history.push(`/user-management/employees/${id}`);
          showBirthCertificate(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:userManagementId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Records"
            // getData={getBirthCertificateList}
            // setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(filter, 'q') || ''}
            keywordPlaceholder="Search Records..."
            listName="Transaction"
            label="Records List"
            renderItem={(item) => (
              <div className="px-3 py-3 text-uppercase">
                <span>
                  {' '}
                  {_.get(item, 'attributes.first_name', '').toUpperCase()}{' '}
                </span>{' '}
                <span>
                  {_.get(item, 'attributes.last_name', '').toUpperCase()}
                </span>
              </div>
            )}
            isLoading={isLoading}
            selected={params.userManagementId}
            data={userManagementList}
            dataPager={userManagementListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:userManagementId?`}
                    render={() => (
                      <BirthCertificateListingContent
                        handleModal={handleModal}
                        // handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        handleViewImage={handleViewImage}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:userManagementId?`}
                  render={() =>
                    !params.userManagementId &&
                    userManagementList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(userManagementList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
            handleChangePage={(page) =>
              setFilter((prev) => ({ ...prev, page }))
            }
          />
        )}
      />
    </div>
  );
}

BirthCertificateListingContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getBirthCertificateList: PropTypes.instanceOf(Function).isRequired,
  userManagementList: PropTypes.instanceOf(Array).isRequired,
  userManagementListPager: PropTypes.instanceOf(Object).isRequired,
  removeUserManagement: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showBirthCertificate: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  userManagementList: _.get(api, `${c.GET_BIRTH_CERTIFICATE}.list`) || [],
  userManagementListPager: _.get(api, `${c.GET_BIRTH_CERTIFICATE}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_BIRTH_CERTIFICATE) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BirthCertificateListingContainer);
